import { IJobsiteSalesArea } from '@cemex-core/cmx-api/models/jobsite-sales-areas/jobsite-sales-area';
import { LotCapacity } from '@cemex-core/cmx-api/models/jobsite-std-lot/lot-capacity';
import { OneClickJobsiteActions, OneClickJobsitesActionTypes } from '../actions/one-click-jobsites.actions';
import { OneClickProfileActions, OneClickProfileActionTypes } from '../actions/one-click-profile.actions';
import { OneClickProject } from '../models/one-click-project.model';

export interface OneClickJobsiteState {
  loading: boolean;
  loadingStdLot: boolean;
  jobsitesAvailable: any[];
  stdLot: LotCapacity;
  salesArea: IJobsiteSalesArea;
  selected: OneClickProject;
}

export const initialState: OneClickJobsiteState = {
  loading: false,
  loadingStdLot: false,
  jobsitesAvailable: [],
  stdLot: null,
  salesArea: null,
  selected: null,
};

export function reducer(
  state = initialState,
  action: OneClickJobsiteActions | OneClickProfileActions,
): OneClickJobsiteState {
  switch (action.type) {
    case OneClickJobsitesActionTypes.LOAD_JOBSITES: {
      return {
        ...state,
        loading: true,
      } as OneClickJobsiteState;
    }
    case OneClickJobsitesActionTypes.LOAD_JOBSITES_COMPLETE: {
      return {
        ...state,
        loading: false,
        jobsitesAvailable: action.payload,
      } as OneClickJobsiteState;
    }
    case OneClickJobsitesActionTypes.SELECT_JOBSITE: {
      return {
        ...state,
        selected: action.payload,
      } as OneClickJobsiteState;
    }
    case OneClickJobsitesActionTypes.LOAD_JOBSITES_SALES_AREA_COMPLETE: {
      return {
        ...state,
        salesArea: action.payload,
      } as OneClickJobsiteState;
    }
    case OneClickJobsitesActionTypes.LOAD_STD_LOT: {
      return {
        ...state,
        loadingStdLot: true,
      };
    }
    case OneClickJobsitesActionTypes.LOAD_STD_LOT_COMPLETED: {
      return {
        ...state,
        stdLot: action.payload,
        loadingStdLot: false,
      } as OneClickJobsiteState;
    }
    case OneClickProfileActionTypes.RESET_BUILDER:
    case OneClickJobsitesActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
